import { useState } from "react";
import { Button } from "primereact/button";
import PrimeDialog from "../../../components/dialog/PrimeDialog";
import { AddUse } from "./dialog/AddUse";
import { useForm } from "react-hook-form";

export const Use = () =>{
    const [addDialog,setAddDialog] = useState(false);
    const { getValues, 
        setValue, 
        control,
        clearErrors, 
        register, 
        handleSubmit, 
        formState: { errors,isValid } } = useForm({
    defaultValues: {
     
    },
     //錯誤驗證時機
    mode: "all"
  })
    return(<>
        <Button label="新增" onClick={()=>setAddDialog(true)}></Button>
        <PrimeDialog
        visible={addDialog}
            title="新增"
            size="lg"
            onClose={() => { setAddDialog(false) }}
            onConfirm={() => { setAddDialog(false) }}
            bodyTemplate={<AddUse
                register = {register}
                errors = {errors}
                control = {control}
                setValue = {setValue}
            ></AddUse>}
            ></PrimeDialog>
    </>)
}